// extracted by mini-css-extract-plugin
module.exports = {"RV-C":"C_RV-C__C0mbl"};